import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
                                                                  
                                                        
  const _component_snackbar = _resolveComponent("snackbar");
                                                      
  return _openBlock(), _createBlock(_component_v_app, {
    id: "mystique_3",
    class: "vuetify3-app-scope"
  }, {
    default: _withCtx(() => [_createVNode(_component_v_main, null, {
      default: _withCtx(() => [_createVNode(_component_v_container, {
        fluid: "",
        class: "ma-0 pa-0 h-100"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_snackbar)]),
    _: 1
  });
}

/* Vuetify */
import { VApp as _component_v_app } from "vuetify/components/VApp"
import { VContainer as _component_v_container } from "vuetify/components/VGrid"
import { VMain as _component_v_main } from "vuetify/components/VMain"

